export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14697.59668598.jpg";